import { useLang } from "../i18n/LangContext";
import { useReveal } from "../hooks/useReveal";

function Stat({ item, index }) {
    const { ref, className } = useReveal(0.1);
    return (
        <div
            ref={ref}
            data-testid={`benefit-${index}`}
            style={{ transitionDelay: `${index * 80}ms` }}
            className={`${className} p-8 lg:p-10 border-r border-b border-white/15 last:border-r-0`}
        >
            <div className="font-display font-bold text-5xl md:text-6xl lg:text-7xl text-mint leading-none tracking-tight">
                {item.value}
            </div>
            <div className="mt-4 text-sm md:text-base text-white/80 leading-relaxed max-w-xs">
                {item.label}
            </div>
        </div>
    );
}

export default function Benefits() {
    const { t } = useLang();
    const { ref, className } = useReveal();
    return (
        <section
            data-testid="benefits-section"
            className="bg-ink text-white py-24 md:py-32 relative overflow-hidden"
        >
            <div className="absolute inset-0 hex-pattern opacity-30 pointer-events-none" />
            <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
                <div ref={ref} className={`${className} max-w-3xl mb-16`}>
                    <div className="flex items-center gap-3 mb-6">
                        <span className="w-10 h-px bg-mint" />
                        <span className="font-display text-xs uppercase tracking-[0.3em] text-mint">
                            {t.benefits.kicker}
                        </span>
                    </div>
                    <h2 className="font-display font-bold uppercase text-4xl md:text-5xl lg:text-6xl leading-[0.95] tracking-tight text-white">
                        {t.benefits.title}
                    </h2>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-l border-t border-white/15">
                    {t.benefits.items.map((it, i) => (
                        <Stat key={i} item={it} index={i} />
                    ))}
                </div>
            </div>
        </section>
    );
}
